// extracted by mini-css-extract-plugin
export default {"use_case_bubbles":"use_case_bubbles___px0Vv","bg":"bg___rnCXz","container":"container___Iv1LR"};